const NewsComponent = () => {
  return (
    <div className="">
      <div className="max-w-[70rem] mx-auto flex justify-between flex-col items-center lg:py-[6.2rem] md:py-[3.5rem] text-[#373737] sm:pt-[2rem] pt-[40px] pb-[3rem]">
        <h1 className="react-reveal font-bold sm:text-4xl text-3xl max-w-[23rem] ">
          In The News
        </h1>
        <hr className="hr" />
        <div className="grid md:flex flex-wrap gap-6 justify-center mt-8 px-4">
          {[
            {
              img: "/Home/HRStrategy.jpg",
              title: "Jazz CEO, Aamir Hafeez Ibrahim meets TCS Leadership",
              date: "14 February 2025",
            },
            {
              img: "/Home/LUMSGroup.jpg",
              title:
                "TCS C Suite Welcome Top Business School (LUMS) Future Leaders",
              date: "16 January 2025",
            },
            {
              img: "/Home/futureSummit.jpg",
              title: "The Future Summit 8th Edition",
              date: "06 November 2024",
            },
          ].map((item, index) => (
            <div
              key={index}
              className="react-reveal flex flex-col flex-1 w-full max-w-[20rem] cursor-pointer 
        transition-all duration-300 hover:shadow-lg rounded-lg overflow-hidden
        bg-white border border-gray-100"
            >
              <div className="relative w-full h-48">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-4 flex flex-col items-center">
                <h2
                  className="font-bold text-lg md:text-xl mb-2 text-center 
          line-clamp-2 hover:text-red-600 transition-colors"
                >
                  {item.title}
                </h2>
                <p className="text-sm text-gray-600">{item.date}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default NewsComponent;
